<template>
  <div class="ltv-header">
    <MobileHeader 
      v-if="isMobileScreen"
      is-live
    />
    <DesktopHeader v-else is-live />
    <!-- <nav
      v-else
      class="navbar navbar-expand py-2 py-cs-0 fixed-top"
    >
      <ul class="navbar-nav mr-auto w-75">
        <li class="nav-item menu-icon">
          <a :href="httpsUrl">
            <img v-bind:src="asset('/home-layout/files/axetv-logo.png')" 
              alt="AXE TV" 
              class="ltv-logo"
            />
          </a>
        </li>
        <li class="nav-item">
          <router-link :to="{name: 'live.home'}" class="nav-link pt-1 ml-2" 
            style="margin-top: 13px;"
            active-class="active live-active"
          >
            <span class="material-icons align-bottom mr-2">
              live_tv
            </span>
            <b>Live</b>
          </router-link>
        </li>
      </ul>
      <form @submit.prevent="handleSubmit()"
        class="d-lg-table w-75 mx-auto ltv-header-search d-none"
      >
        <div class="d-table-cell">
          <input 
            type="text" 
            class="form-control" 
            placeholder="Search channels..."
            v-model="keyword"
          />
        </div>
        <div class="d-table-cell">
          <button type="submit" class="btn btn-1">
            <span class="material-icons">
              search
            </span>
          </button>
        </div>
      </form>
      <ul class="navbar-nav ml-auto">
        <li class="nav-item dropdown nav-user">
          <a class="nav-link dropdown-toggle mr-0" 
            href="#" 
            id="navbarDropdown" 
            role="button" 
            data-toggle="dropdown" 
            aria-haspopup="true" 
            aria-expanded="false"
          >
            <i class="material-icons">
              person
            </i>
          </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
            <a class="dropdown-item" 
              :href="httpsUrl + '#/profile'"
            >
              <i class="material-icons">person</i>
              Profile
            </a>
            <a class="dropdown-item" 
              :href="httpsUrl + '#/category/favorites'"
            >
              <i class="material-icons">star</i>
              My Favorites
            </a>
            <a class="dropdown-item" 
              :href="httpsUrl + '#/category/watch-later'"
            >
              <i class="material-icons">watch_later</i>
              Watch Later
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="#" @click.prevent="logout()">
              <i class="material-icons">lock</i>
              Logout</a>
          </div>
        </li>
      </ul>
    </nav> -->
  </div>
</template>


<script>
import { isMobile } from 'mobile-device-detect';
import $ from 'jquery'
import { logout } from '../app/helpers';
import { httpsUrl } from '../app/config';
import MobileHeader from './Header';
import DesktopHeader from './v2/__DesktopHeader';
export default {

  components: {
    MobileHeader,
    DesktopHeader
  },

  data() {
    return {
      keyword: '',
      httpsUrl,
      isMobileScreen: false,
    }
  },


  mounted() {
    this.setQuery();

    this.checkSmallerDevice();

    $(window).resize(() => {
      this.checkSmallerDevice();
    })
  },


  methods: {
    handleSubmit() {
      const { keyword } = this;

      this.$router.push({
        name: 'live.search',
        query: {
          keyword
        }
      })
    },

    setQuery() {
      this.keyword = this.$route.query.keyword || '';
    },

    logout() {
      logout(this.$router, true);
    },

    checkSmallerDevice() {
      const windowWidth = $(window).width();
      
      if (isMobile || windowWidth < 1055) {
        this.isMobileScreen = true;
      } else {
        this.isMobileScreen = false;
      }
    }
  },

  watch: {
    $route() {
      this.setQuery();
    }
  }
  
}
</script>


<style lang="scss" scoped>
.ltv-logo {
  max-width: 106px;
  margin: 5px auto;
}
.ltv-header-text {
  background: green;
  padding: 0px 10px;
  color: white;
  margin: 17px 0px;
  display: inline-block;
  font-size: 13px;
  letter-spacing: 1px;
  font-weight: 500;
  border-radius: 2px;
  width: 56px;
  padding-left: 6px;
  margin-top: 22px;
  margin-left: 9px;
  position: absolute;

  i {
    display: inline-block;
    width: 7px;
    height: 7px;
    background: white;
    border-radius: 100px;
    margin-right: 4px;
    position: relative;
    top: -1px;
  }
}
.ltv-panel {
  margin-top: 50px;

  .ltv-sidebar {
    background: #212121;
  }

  .ltv-sidebar-header {
    padding: 10px 25px;

    h4 {
      font-size: 16px;
      color: white;
      font-weight: 500;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }

    .dropdown-menu {
      background: #010101;
      box-shadow: 0px 0px 13px -1px #0a0a0a;
      border: 1px solid #101010;
    }

    .dropdown-item:hover {
      color: red;
      background:transparent;
    }

    span {
      color: white;
      font-size: 12px;
    }
  }
  
}

.ltv-header-search {
  height: 100%;
  padding: 10px 0px;
  width: calc(100% - 400px);
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  max-width: 580px;

  input[type="text"] {
      padding: 5px 15px;
      width: 100%;
      border: 1px solid #252525;
      border-radius: 4px;
      font-size: 14px;
      color: #8c8c8c;
      padding-right: 40px;
      background: #171717;
      &:focus {
        box-shadow: 0 0 0 0.2rem rgba(249, 68, 62, 0.28);
      }
  }

  button {
      position: absolute;
      right: 0px;
      padding: 4px 12px;
      background: transparent;
      border: none;
  }

  button span {
      vertical-align: middle;
      font-size: 27px;
      color: #464646;
  }
}

.nav-user a#navbarDropdown {
    background: whitesmoke;
    color: black;
    padding: 5px 8px !important;
    min-width: auto;
    border-radius: 40px;
}

.nav-user a#navbarDropdown i {
    font-size: 28px;
}

.nav-user a#navbarDropdown:hover {
    color: #C70C13;
    transition: all .1s linear;
}

nav.navbar .dropdown-menu {
  background-color: #292828f2;
  padding: 10px;
}

.dropdown-item {
  padding: 5px 16px;
  border-radius: 4px;
  font-size: 14px;
  text-transform: capitalize;
  margin-bottom: 7px;
  padding-left: 11px;

  i.material-icons {
    vertical-align: bottom;
    margin-right: 5px;
    font-size: 18px;
  }
}

ul.navbar-nav a.nav-link {
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: rgba(255,255,255,.7);
    background: rgba(255,255,255,.05);
    border-radius: 3px;
    border-left: none;
    position: relative;
    margin-right: 9px;
    padding-left: 15px !important;
    padding-right: 15px !important;
    &:hover {
      background: #C70C13;
      transition-duration: .3s;
      color: white;
    }
    &.disabled, &.active {
      background: rgb(163, 7, 12);
      transition-duration: .2s;
      color: white;
      &.live-active {
        background: green;
      }
      .live-dot {
        background: red;
      }
    }
}
</style>